import React, { memo, useContext, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from './assets/styles/picker.styles'
import ColorPicker from './ColorPicker'
import FormatPicker from './FormatPicker'
import Button from '@material-ui/core/Button'
import replayIcon from './assets/images/replay.svg'
import photoCombinations from './assets/combinations'
import FadeInHOC from '../FadeInHOC'
import clsx from 'clsx'
import { ColoriFormatiPageConfig } from '../../configuration'
import { useMediaQuery } from '@material-ui/core'
import { tablet } from '../mediaQueries'
import { PickerContext, PickerDispatch } from '../app/contexts/picket.context'

const useStyles = makeStyles(styles)

function PhotoPicker() {
    // context
    const combinations = useContext(PickerContext)
    const dispatch = useContext(PickerDispatch)
    const [visibleCombinations, setVisibleCombinations] = useState({
        color: 1,
        format: 2
    })
    const setVisibleColor = color => {
        setVisibleCombinations({ ...visibleCombinations, color })
    }
    const setVisibleFormat = format => {
        setVisibleCombinations({ ...visibleCombinations, format })
    }
    const [isFading, setFading] = useState(false)
    // actions
    const guaranteeRandomNum = (oldNum, max) => {
        let newNum = Math.floor(Math.random() * max)
        while (true) {
            if (newNum !== oldNum) break
            else newNum = Math.floor(Math.random() * max)
        }
        return newNum
    }
    const fadeImageOnChange = fn => {
        setFading(true)
        setTimeout(() => {
            fn()
            setFading(false)
        }, 300);
    }
    const generateRandomCombo = () => {
        const randomColor = guaranteeRandomNum(combinations.color, ColoriFormatiPageConfig.colors.length)
        const randomFormat = guaranteeRandomNum(combinations.format, ColoriFormatiPageConfig.formats.length)
        setVisibleCombinations({ color: randomColor, format: randomFormat })
        fadeImageOnChange(() => dispatch({
            type: 'RANDOM_COMBO',
            payload: {
                color: randomColor,
                format: randomFormat
            }
        }))
    }
    // styles
    const isMobile = useMediaQuery(`(max-width: ${tablet}px)`)
    const src = photoCombinations[combinations.color + 1][combinations.format + 1].image
    const classes = useStyles()
    return (
        <div className={classes.root} >
            <span className={classes.span} >
                <FadeInHOC rootClass={classes.listSpan} seconds={3} >
                    <ColorPicker
                        index={visibleCombinations.color}
                        handleFade={fadeImageOnChange}
                        setVisibleColor={setVisibleColor}
                    />
                    <FormatPicker
                        index={visibleCombinations.format}
                        handleFade={fadeImageOnChange}
                        setVisibleFormat={setVisibleFormat}
                    />
                </FadeInHOC>
                {!isMobile && <Button
                    onClick={generateRandomCombo}
                    variant='outlined'
                    className={classes.btn}
                    endIcon={<img src={replayIcon} alt='replay icon' />}
                >
                    {ColoriFormatiPageConfig.content.tertiary[3]}
                </Button>}
            </span>
            <FadeInHOC rootClass={classes.imageWrap} >
                <p className={classes.p} >{ColoriFormatiPageConfig.content.tertiary[0]}</p>
                <img className={clsx(classes.image, isFading && classes.imageFade)} src={src} alt='combination' />
                {isMobile && <Button
                    onClick={generateRandomCombo}
                    variant='outlined'
                    className={classes.btn}
                    endIcon={<img className={classes.replayIcon} src={replayIcon} alt='replay icon' />}
                >
                    {ColoriFormatiPageConfig.content.tertiary[3]}
                </Button>}
            </FadeInHOC>
        </div>
    )
}

export default memo(PhotoPicker)